/**
 * Shared business logic - Framework agnostic
 * Can be used by Angular, React, and Node.js backend
 */

// Export validators
export * from "./validators";

// Export Excel utilities
export * from "./excel";

// Export utility functions
export * from "./utils";

// Export services
export * from "./services";

/**
 * Calculation utilities
 */
export class PointsCalculator {
  static calculateEnrollmentPoints(enrollmentType: string): number {
    // Example business logic - replace with your actual logic
    const pointsMap: Record<string, number> = {
      standard: 100,
      premium: 250,
      vip: 500,
    };
    return pointsMap[enrollmentType] || 0;
  }
}

/**
 * Date utilities
 */
export class DateUtils {
  static formatDate(date: Date): string {
    return date.toISOString().split("T")[0];
  }

  static isDateInFuture(date: Date): boolean {
    return date.getTime() > Date.now();
  }
}
